/* GELA Theme — theme.js */
'use strict';

/* ── Livraison : paramètres modifiables ──────────── */
const FREE_SHIPPING_THRESHOLD = 8900;   /* seuil de livraison offerte, en centimes (89 €) */
const SHIPPING_FEE_LABEL      = '6,90 €'; /* tarif standard affiché sous le seuil */

/* ── Page Loader ─────────────────────────────────── */
const loader = document.getElementById('page-loader');
if (loader) {
  /* Vitesse : l'écran « G » n'attend plus le chargement complet de la page (images, apps).
     1re page de la visite : bref passage de 300 ms ; pages suivantes : retiré tout de suite. */
  let loaderSeen = false;
  try {
    loaderSeen = sessionStorage.getItem('gela_loader_seen') === '1';
    sessionStorage.setItem('gela_loader_seen', '1');
  } catch (e) {}
  const hideLoader = () => loader.classList.add('is-hidden');
  if (loaderSeen) hideLoader(); else setTimeout(hideLoader, 300);
}

/* ── Scroll reveal ───────────────────────────────── */
const revealObserver = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
}, { threshold: 0.1 });
document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

/* ── Header transparent + scroll ────────────────── */
(function () {
  var hdr = document.getElementById('site-header');
  if (!hdr) return;
  var trans = hdr.dataset.transparent === 'true';

  /* Le seuil de bascule était fixé à 60px : sur un hero de ~95vh, le moindre
     scroll (60px, une simple molette) faisait passer le header en mode
     "scrollé" opaque alors que la photo du hero était encore presque
     entièrement visible en dessous → un bandeau blanc plein qui tombe en
     plein milieu de l'image, très moche, dès le tout premier scroll.
     On calcule maintenant un seuil dynamique : le header ne devient opaque
     qu'une fois qu'on a réellement dépassé (ou presque) le hero, et non au
     premier pixel de scroll. */
  var heroEl = document.querySelector('.hero, .hero-carousel');

  function getThreshold() {
    if (heroEl) {
      return Math.max(heroEl.offsetHeight - hdr.offsetHeight - 40, 120);
    }
    return window.innerHeight * 0.6;
  }

  function upd() {
    var s = window.scrollY > getThreshold();
    hdr.classList.toggle('is-scrolled', s);
    /* Colle le header sous le bandeau d'annonce puis tout en haut, sans trou pendant le scroll (mobile) */
    var annBar = document.querySelector('.announcement-bar, #announcement-bar, [class*="announcement"]');
    var annBottom = annBar ? Math.max(0, annBar.getBoundingClientRect().bottom) : 0;
    hdr.style.transition = 'background .35s ease, box-shadow .3s ease, height .3s ease';
    hdr.style.top = s ? '0px' : annBottom + 'px';
    if (trans) hdr.classList.toggle('site-header--transparent', !s);
  }
  window.addEventListener('scroll', upd, { passive: true });
  window.addEventListener('resize', upd);
  upd();
})();

/* ── Search drawer ───────────────────────────────── */
(function () {
  var drw = document.getElementById('search-drawer');
  var btn = document.getElementById('search-toggle');
  var cls = document.getElementById('search-close');
  var inp = document.getElementById('search-input');
  if (!drw) return;
  function open() {
    drw.classList.add('is-open');
    drw.setAttribute('aria-hidden', 'false');
    btn && btn.setAttribute('aria-expanded', 'true');
    setTimeout(function () { inp && inp.focus(); }, 50);
  }
  function shut() {
    drw.classList.remove('is-open');
    drw.setAttribute('aria-hidden', 'true');
    btn && btn.setAttribute('aria-expanded', 'false');
  }
  btn && btn.addEventListener('click', open);
  cls && cls.addEventListener('click', shut);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
})();

/* ── Mobile drawer ───────────────────────────────── */
(function () {
  var bgr = document.getElementById('header-burger');
  var drw = document.getElementById('mobile-drawer');
  var ovl = document.getElementById('mobile-overlay');
  var cls = document.getElementById('mobile-close');
  if (!bgr) return;
  function open() {
    drw && drw.classList.add('is-open');
    ovl && ovl.classList.add('is-open');
    drw && drw.setAttribute('aria-hidden', 'false');
    bgr.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function shut() {
    drw && drw.classList.remove('is-open');
    ovl && ovl.classList.remove('is-open');
    drw && drw.setAttribute('aria-hidden', 'true');
    bgr.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  bgr.addEventListener('click', open);
  cls && cls.addEventListener('click', shut);
  ovl && ovl.addEventListener('click', shut);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
})();

/* ── Announcement bar dismiss ────────────────────── */
const announceDismiss = document.getElementById('announcement-dismiss');
if (announceDismiss) {
  announceDismiss.addEventListener('click', () => {
    document.getElementById('announcement-bar')?.classList.add('is-hidden');
  });
}

/* ── Cart drawer ─────────────────────────────────── */
const cartDrawer  = document.getElementById('cart-drawer');
const cartOverlay = document.getElementById('cart-drawer-overlay');

const openCart  = () => {
  cartDrawer?.classList.add('is-open');
  cartOverlay?.classList.add('is-open');
  document.body.style.overflow = 'hidden';
};
const closeCart = () => {
  cartDrawer?.classList.remove('is-open');
  cartOverlay?.classList.remove('is-open');
  document.body.style.overflow = '';
};

document.getElementById('cart-drawer-close')?.addEventListener('click', closeCart);
cartOverlay?.addEventListener('click', closeCart);
document.querySelectorAll('[data-open-cart]').forEach(btn =>
  btn.addEventListener('click', e => { e.preventDefault(); openCart(); })
);

/* ── Add to cart ─────────────────────────────────── */
async function addToCart(variantId, quantity = 1) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    await updateCartDrawer();
    openCart();
  } catch (err) { console.error(err); }
}

async function updateCartDrawer() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    renderCartDrawer(cart);
    updateCartCount(cart.item_count);
    updateProgressBar(cart.total_price);
  } catch (err) { console.error(err); }
}

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = count;
    el.setAttribute('data-count', count);
    count > 0 ? el.removeAttribute('hidden') : el.setAttribute('hidden', '');
  });
}

function updateProgressBar(totalPrice) {
  const threshold = FREE_SHIPPING_THRESHOLD;
  const bar  = document.querySelector('.cart-drawer__progress-fill');
  const text = document.querySelector('.cart-drawer__progress-text');
  const sub  = document.querySelector('.cart-drawer__progress-sub');
  if (!bar || !text) return;
  bar.style.width = Math.min((totalPrice / threshold) * 100, 100) + '%';
  if (totalPrice >= threshold) {
    text.textContent = 'Livraison offerte ! 🎉';
    if (sub) sub.textContent = '';
  } else {
    const remaining = ((threshold - totalPrice) / 100).toFixed(2).replace('.', ',');
    text.textContent = `Plus que ${remaining} € pour la livraison offerte`;
    if (sub) sub.textContent = '';
  }
}

function renderCartDrawer(cart) {
  const body   = document.querySelector('.cart-drawer__body');
  const footer = document.querySelector('.cart-drawer__footer');
  if (!body || !footer) return;

  if (cart.item_count === 0) {
    body.innerHTML = `
      <div class="cart-drawer__empty">
        <div class="cart-drawer__empty-icon">
          <svg fill="none" stroke="currentColor" stroke-width="1" viewBox="0 0 24 24">
            <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 01-8 0"/>
          </svg>
        </div>
        <p>Votre panier est vide</p>
      </div>`;
    footer.innerHTML = '';
    return;
  }

  const progressHTML = `
    <div class="cart-drawer__progress">
      <p class="cart-drawer__progress-text"></p>
      <div class="cart-drawer__progress-bar">
        <div class="cart-drawer__progress-fill" style="width:0%"></div>
      </div>
      <p class="cart-drawer__progress-sub" style="margin:8px 0 0;font-size:11px;letter-spacing:.04em;text-align:center;color:#777;"></p>
    </div>`;

  const itemsHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <a href="${item.url}" class="cart-item__img-link">
        <img class="cart-item__img"
             src="${item.image}"
             alt="${item.title}"
             width="80" height="100"
             loading="lazy">
      </a>
      <div class="cart-item__details">
        <a href="${item.url}" class="cart-item__title-link">
          <p class="cart-item__title">${item.product_title}</p>
        </a>
        <p class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
        <div class="cart-item__actions">
          <div class="cart-item__qty">
            <button data-qty-change="${item.key}" data-delta="-1">−</button>
            <span>${item.quantity}</span>
            <button data-qty-change="${item.key}" data-delta="1">+</button>
          </div>
          <span class="cart-item__price">${formatMoney(item.line_price)}</span>
        </div>
        <button class="cart-item__remove" data-remove="${item.key}">Retirer</button>
      </div>
    </div>`).join('');

  body.innerHTML = progressHTML + itemsHTML;
  updateProgressBar(cart.total_price);

  footer.innerHTML = `
    <div class="cart-drawer__total">
      <span class="cart-drawer__total-label">Total</span>
      <span class="cart-drawer__total-amount">${formatMoney(cart.total_price)}</span>
    </div>
    <a href="/checkout" class="btn btn-primary cart-drawer__checkout">Passer commande →</a>
    <p class="cart-drawer__reassure" style="margin:14px 0 0;font-size:11px;letter-spacing:.04em;text-align:center;color:#777;line-height:1.6;">Écrin offert · Garantie 2 ans · Paiement en 3x avec Klarna</p>`;

  body.querySelectorAll('[data-qty-change]').forEach(btn => {
    btn.addEventListener('click', () => {
      const key  = btn.dataset.qtyChange;
      const item = cart.items.find(i => i.key === key);
      if (!item) return;
      changeCartQty(key, Math.max(0, item.quantity + parseInt(btn.dataset.delta)));
    });
  });
  body.querySelectorAll('[data-remove]').forEach(btn => {
    btn.addEventListener('click', () => changeCartQty(btn.dataset.remove, 0));
  });
glRenderPairing(body, cart);
glEtaInto(footer);
}

async function changeCartQty(key, quantity) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });
  await updateCartDrawer();
}

function formatMoney(cents) {
  return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
}

/* — Bijoux à associer dans le panier latéral ———————————————— */
async function glRenderPairing(body, cart) {
  try {
    const first = cart.items[0];
    if (!first) return;
    const inCart = new Set(cart.items.map(i => i.product_id));
    const getRecs = async (intent) => {
      const r = await fetch(`/recommendations/products.json?product_id=${first.product_id}&limit=8${intent ? '&intent=' + intent : ''}`);
      if (!r.ok) return [];
      const d = await r.json();
      return d.products || [];
    };
    let prods = await getRecs('complementary');
    if (prods.length === 0) prods = await getRecs('');
    prods = prods.filter(p => p.available && !inCart.has(p.id)).slice(0, 2);
    if (!prods.length || body.querySelector('.cart-pair')) return;
    const esc = s => String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    const items = prods.map(p => {
      const v = p.variants.find(x => x.available) || p.variants[0];
      const src = p.featured_image ? p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=160' : '';
      return `<div class="cart-pair__item">
        <a href="${p.url}" class="cart-pair__img"><img src="${src}" alt="${esc(p.title)}" width="56" height="56" loading="lazy"></a>
        <div class="cart-pair__info"><a href="${p.url}" class="cart-pair__name">${esc(p.title)}</a><span class="cart-pair__price">${formatMoney(p.price)}</span></div>
        <button type="button" class="cart-pair__add" data-quick-add="${v.id}">Ajouter</button>
      </div>`;
    }).join('');
    body.insertAdjacentHTML('beforeend', `<div class="cart-pair"><p class="cart-pair__title">À associer</p>${items}</div>`);
  } catch (e) { console.error(e); }
}

/* — Date de livraison estimée (FAQ : 8 à 10 jours ouvrés) ——————— */
const GL_ETA_MIN = 8;
const GL_ETA_MAX = 10;
function glEtaText(minD, maxD) {
  const H = ['1-1', '5-1', '5-8', '7-14', '8-15', '11-1', '11-11', '12-25']; /* jours fériés fixes */
  const add = n => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6 && !H.includes((d.getMonth() + 1) + '-' + d.getDate())) k++; } return d; };
  const f = d => d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
  return `Livraison estimée entre le <strong>${f(add(minD))}</strong> et le <strong>${f(add(maxD))}</strong>`;
}
window.glEtaText = glEtaText;
function glEtaInto(footer) {
  if (footer.querySelector('.cart-drawer__eta')) return;
  const p = document.createElement('p');
  p.className = 'cart-drawer__eta';
  p.innerHTML = glEtaText(GL_ETA_MIN, GL_ETA_MAX);
  const btn = footer.querySelector('.cart-drawer__checkout');
  if (btn) btn.insertAdjacentElement('beforebegin', p); else footer.appendChild(p);
}
document.querySelectorAll('[data-gl-eta]').forEach(el => { el.innerHTML = glEtaText(GL_ETA_MIN, GL_ETA_MAX); });


/* ── Quick add ───────────────────────────────────── */
document.addEventListener('click', e => {
  const btn = e.target.closest('[data-quick-add]');
  if (!btn) return;
  e.preventDefault();
  if (btn.dataset.quickAdd) addToCart(parseInt(btn.dataset.quickAdd));
});

/* ── Product gallery ─────────────────────────────── */
const gallery = document.querySelector('.product-gallery');
if (gallery) {
  const mainImg = gallery.querySelector('.product-gallery__main img');
  gallery.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      gallery.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (mainImg) mainImg.src = thumb.querySelector('img').src;
    });
  });
}

/* ── Variant selection ───────────────────────────── */
document.querySelectorAll('.variant-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.closest('.product-info__variants')?.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
    const atc = document.querySelector('[data-atc-main]');
    if (atc) atc.dataset.variantId = btn.dataset.variantId;
  });
});
document.querySelector('[data-atc-main]')?.addEventListener('click', function () {
  const id = this.dataset.variantId || this.dataset.defaultVariant;
  if (id) addToCart(id);
});

/* ── Accordions ──────────────────────────────────── */
document.querySelectorAll('.accordion__trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    document.querySelectorAll('.accordion__trigger').forEach(t => {
      t.setAttribute('aria-expanded', 'false');
      t.nextElementSibling.style.maxHeight = null;
    });
    if (!expanded) {
      trigger.setAttribute('aria-expanded', 'true');
      trigger.nextElementSibling.style.maxHeight = trigger.nextElementSibling.scrollHeight + 'px';
    }
  });
});

/* ── Testimonials slider ─────────────────────────── */
const slider = document.querySelector('.testimonials__slider');
if (slider) {
  const track = slider.querySelector('.testimonials__track');
  const dots  = slider.querySelectorAll('.testimonials__dot');
  let current = 0;
  const go = i => {
    current = i;
    track.style.transform = `translateX(-${i * 100}%)`;
    dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
  };
  dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
  setInterval(() => go((current + 1) % dots.length), 5000);
}

/* ── Wishlist ────────────────────────────────────── */
const WL_KEY = 'gela_wishlist';
const getWishlist  = () => { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch { return []; } };
const saveWishlist = wl => localStorage.setItem(WL_KEY, JSON.stringify(wl));

function initWishlistBtns() {
  document.querySelectorAll('.btn-wishlist, .btn-wishlist-main').forEach(btn => {
    const pid = btn.dataset.productId;
    if (!pid) return;
    if (getWishlist().includes(pid)) btn.classList.add('is-active');
    btn.addEventListener('click', e => {
      e.preventDefault();
      let wl = getWishlist();
      if (wl.includes(pid)) {
        wl = wl.filter(id => id !== pid);
        btn.classList.remove('is-active');
      } else {
        wl.push(pid);
        btn.classList.add('is-active');
        btn.animate(
          [{ transform: 'scale(1)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }],
          { duration: 300 }
        );
      }
      saveWishlist(wl);
    });
  });
}
initWishlistBtns();

/* ── Init cart on load ───────────────────────────── */
fetch('/cart.js')
  .then(r => r.json())
  .then(cart => {
    updateCartCount(cart.item_count);
    renderCartDrawer(cart);
  })
  .catch(() => {});

/* ── Nav dropdown ────────────────────────────────── */
document.querySelectorAll('.nav-dropdown__trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    document.querySelectorAll('.nav-dropdown__trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));
    trigger.setAttribute('aria-expanded', String(!isOpen));
  });
});
document.addEventListener('click', e => {
  if (!e.target.closest('.nav-dropdown')) {
    document.querySelectorAll('.nav-dropdown__trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));
  }
});

/* ── Hero Carousel ───────────────────────────────── */
(function () {
  const carousel = document.querySelector('.hero-carousel');
  if (!carousel) return;

  const slides  = carousel.querySelectorAll('.hero-carousel__slide');
  const dots    = carousel.querySelectorAll('.hero-carousel__dot');
  const prevBtn = carousel.querySelector('.hero-carousel__arrow--prev');
  const nextBtn = carousel.querySelector('.hero-carousel__arrow--next');
  const speed   = carousel.dataset.autoplay ? parseInt(carousel.dataset.autoplay) * 1000 : 5000;
  let current   = 0;
  let timer     = null;

  function goTo(index) {
    slides[current].setAttribute('aria-hidden', 'true');
    slides[current].style.opacity = '0';
    dots[current]?.classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].setAttribute('aria-hidden', 'false');
    slides[current].style.opacity = '1';
    dots[current]?.classList.add('is-active');
  }

  slides.forEach((s, i) => {
    s.style.position   = 'absolute';
    s.style.inset      = '0';
    s.style.minWidth   = '100%';
    s.style.opacity    = i === 0 ? '1' : '0';
    s.style.transition = 'opacity .8s ease';
  });

  prevBtn?.addEventListener('click', () => { clearInterval(timer); goTo(current - 1); startAuto(); });
  nextBtn?.addEventListener('click', () => { clearInterval(timer); goTo(current + 1); startAuto(); });
  dots.forEach((dot, i) => dot.addEventListener('click', () => { clearInterval(timer); goTo(i); startAuto(); }));

  let startX = 0;
  carousel.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
  carousel.addEventListener('touchend', e => {
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) { clearInterval(timer); goTo(current + (diff > 0 ? 1 : -1)); startAuto(); }
  });

  function startAuto() {
    if (speed === 0 || slides.length < 2) return;
    timer = setInterval(() => goTo(current + 1), speed);
  }
  startAuto();
})();

/* ── Swatches cartes produit ─────────────────────── */
(function () {

  /* Survol : aperçu temporaire */
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('.product-card__swatch[data-image]');
    if (!sw || !sw.dataset.image) return;
    var card = sw.closest('.product-card');
    if (!card) return;
    var img = card.querySelector('.product-card__img--main');
    if (!img) return;
    if (!img.dataset.origSrc) img.dataset.origSrc = img.src;
    img.src = sw.dataset.image;
  });

  /* Mouseout : restaure l'image d'origine
     sauf si une pastille est déjà sélectionnée */
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest('.product-card__swatch[data-image]');
    if (!sw) return;
    var card = sw.closest('.product-card');
    if (!card) return;
    var img = card.querySelector('.product-card__img--main');
    if (!img) return;
    var selected = card.querySelector('.product-card__swatch.is-selected');
    if (selected && selected.dataset.image) {
      img.src = selected.dataset.image;
    } else if (img.dataset.origSrc) {
      img.src = img.dataset.origSrc;
    }
  });

  /* Clic : fixe l'image et marque la pastille comme sélectionnée
     puis laisse le lien <a> naviguer vers la fiche produit */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.product-card__swatch[data-image]');
    if (!sw) return;
    var card = sw.closest('.product-card');
    if (!card) return;
    var img = card.querySelector('.product-card__img--main');
    if (!img) return;

    /* Mémorise l'original si pas encore fait */
    if (!img.dataset.origSrc) img.dataset.origSrc = img.src;

    /* Désélectionne toutes les pastilles de cette carte */
    card.querySelectorAll('.product-card__swatch').forEach(function (s) {
      s.classList.remove('is-selected');
    });

    /* Sélectionne la pastille cliquée */
    sw.classList.add('is-selected');

    /* Met à jour l'image */
    if (sw.dataset.image) img.src = sw.dataset.image;

    /* Le lien <a> navigue normalement après */
  });

})();

/* — Badge « Vu à Cannes » sur toutes les cartes produit (accueil, collections, recherche, à associer) — */
(function () {
  const HANDLES = ['gigi', 'serena', 'ear-cuff-elixir']; /* bijoux portés à Cannes */
  const BEST = ['kylie']; /* badge Best seller */
  const isCannes = href => { const m = (href || '').match(/\/products\/([^/?#]+)/); return !!m && HANDLES.includes(m[1]); };
  const TARGETS = '.product-card__img-wrap, .sug-card__img-wrap';
  function tag() {
    document.querySelectorAll(TARGETS).forEach(wrap => {
      if (wrap.querySelector('.gl-cannes-badge')) return;
      const card = wrap.closest('.product-card, .sug-card');
      const link = wrap.closest('a[href*="/products/"]') || wrap.querySelector('a[href*="/products/"]') || (card && card.querySelector('a[href*="/products/"]')) || (card && card.matches('a') ? card : null);
      if (!link) return;
      const mh = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      const h = mh ? mh[1] : '';
      const label = HANDLES.includes(h) ? '★ Vu à Cannes' : (BEST.includes(h) ? 'Best seller' : '');
      if (!label) return;
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
      wrap.insertAdjacentHTML('beforeend', '<span class="gl-cannes-badge">' + label + '</span>');
    });
  }
  let queued = false;
  const run = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; tag(); }); };
  run();
  new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
})();

/* — Nos Iconiques : Gigi toujours en première position (tous les onglets) — */
(function () {
  const FIRST = 'gigi';
  const re = new RegExp('/products/' + FIRST + '([?#]|$)');
  function reorder() {
    document.querySelectorAll('.fp-track').forEach(track => {
      const card = Array.prototype.find.call(track.children, el => { const a = el.querySelector('a[href*="/products/"]'); return a && re.test(a.getAttribute('href')); });
      if (card && track.firstElementChild !== card) { track.prepend(card); }
      const outer = track.closest('.fp-track-outer') || track.parentElement;
      if (card && !track.dataset.glReset) { outer.scrollLeft = 0; }
    });
  }
  reorder();
  window.addEventListener('load', () => { reorder(); setTimeout(reorder, 600); });
  document.querySelectorAll('.fp-track').forEach(t => new MutationObserver(reorder).observe(t, { childList: true }));
})();


/* — Fiche produit mobile : supprime l'espace vide entre le header et la photo — */
(function () {
  const wrap = document.querySelector('.pdp-wrap');
  const hdr = document.querySelector('.site-header');
  if (!wrap || !hdr) return;
  function fit() {
    wrap.style.marginTop = '';
    if (window.innerWidth > 900 || window.scrollY > 0) return;
    const gap = Math.round(wrap.getBoundingClientRect().top - hdr.getBoundingClientRect().bottom);
    if (gap > 4) wrap.style.marginTop = (-gap) + 'px';
  }
  fit();
  window.addEventListener('load', fit);
})();
